import {call, select, put} from "redux-saga/effects"

import api from "../../services/ApiService"
import {PagesCreators as Creators} from "./redux"
import {LangSwitchCreators as LangCreators} from "../../components/LangSwitch/redux"
import {AppCreators} from "../App/redux"
import {readableErrors} from "../../utils"

export default function* router(dispatch, {payload}) {
  let state = yield select()
  let slug = ""
  const lang = state.router.params.lang
  const preview = typeof state.router.query.preview !== "undefined"
  const useId = typeof state.router.query.use_id !== "undefined"

  if (typeof payload.params.slug === "undefined") {
    slug = payload.pathname.replace(`/${lang}`, "")
  } else {
    slug = payload.params.slug
  }

  if (typeof payload.params.id !== "undefined") {
    slug = payload.params.id
  }

  yield put(Creators.request(slug))

  try {
    const contentResponse = yield call(
      api.getPageContentBySlug,
      slug,
      lang,
      preview,
      useId
    )

    yield put(Creators.success(contentResponse))

    state = yield select()
    let langurl
    lang === "de"
      ? (langurl = state.router.route
          .replace("/:lang/", "/en/")
          .replace(":slug", state.pages.post.translations.en))
      : (langurl = state.router.route
          .replace("/:lang/", "/de/")
          .replace(":slug", state.pages.post.translations.de))
    yield put(LangCreators.success(langurl))

    // tracking
    yield put(
      AppCreators.trackingAdd({
        event: "mtm.virtualPageView",
        section: "pages",
        page_type: "page",
        page_name: contentResponse.post_title,
        document_title: contentResponse.post_title
      })
    )
  } catch (e) {
    yield put(Creators.error(readableErrors(e)))
  }
}



// WEBPACK FOOTER //
// ./src/containers/Pages/sagas.js